import { BananaTypeProps } from "../../types/BananaType";

type BananaCardProps = {
  banana: BananaTypeProps;
  selected?: boolean;
  onSelect?: (item: BananaTypeProps) => void;
  className?: string;
  disabled?: boolean;
};

export const SendBananaCard: React.FC<BananaCardProps> = ({
  banana,
  selected = false,
  onSelect,
  className = "",
  disabled = false,
}) => {
  const base =
    "w-full max-w-2xl group flex flex-col sm:flex-row items-center text-left rounded-xl p-4 transition shadow bg-white";
  const selectStyles = selected
    ? "border-2 border-yellow-500 ring-4 ring-yellow-100"
    : "border-2 border-gray-200 hover:border-yellow-400 hover:shadow-md";
  const focusStyles =
    "focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow-200";
  const disabledStyles = disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer";

  return (
    <button
      type="button"
      aria-pressed={selected}
      aria-label={`Select ${banana.title}`}
      disabled={disabled}
      onClick={() => {
        if (!onSelect || disabled) return;
        onSelect(banana)
      }}
      className={`${base} ${selectStyles} ${focusStyles} ${disabledStyles} ${className}`}
    >
      <img
        src={banana.img}
        alt={banana.title}
        className="w-48 h-48 object-contain mb-4 sm:mb-0 sm:mr-4 flex-shrink-0"
      />

      <div className="flex-1">
        <h4 className="text-xl font-semibold flex items-center gap-2">
          {banana.title}
        </h4>
        <p className="text-gray-600">{banana.description}</p>
      </div>

      {/* subtle affordance */}
      <svg
        className="block mt-6 sm:ml-4 sm:mt-0 opacity-60 group-hover:opacity-100 transition"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <path d="M7 4l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" />
      </svg>
    </button>
  );
};